import { Certificate } from '@revenuemarket/bank';
import { ConnectedCodefCertificate } from '~models/certificate';
import { CodefCertificateBase, RefinedCodefCert } from '~types/codef';

export const checkDuplicateCert = (
  registeredCert: ConnectedCodefCertificate | Certificate | CodefCertificateBase,
  cert: ConnectedCodefCertificate | RefinedCodefCert,
) => {
  return (
    registeredCert.certificateOwner === cert.certificateOwner &&
    registeredCert.certificateAuthority === cert.certificateAuthority &&
    registeredCert.certificateExpireDate === cert.certificateExpireDate &&
    registeredCert.certificateType === cert.certificateType
  );
};
